export enum ContactCategoryEnum {
  REPORT = 'Report issue',
  QUESTION = 'Ask a question',
  SUGGEST = 'Suggest feature',
  CONTACT = 'Contact sales',
  FEEDBACK = 'Share feedback',
}
